import { render, staticRenderFns } from "./Loja.vue?vue&type=template&id=7a2a3bbe&scoped=true"
import script from "./Loja.vue?vue&type=script&lang=js"
export * from "./Loja.vue?vue&type=script&lang=js"
import style0 from "./Loja.vue?vue&type=style&index=0&id=7a2a3bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2a3bbe",
  null
  
)

export default component.exports